module.exports = __webpack_public_path__ + "static/media/logo-full.b9a2e573.png";